/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/9/30 10:29
 * @FileName: realTimeCurrency.js
 * @LastEditor: 2022/9/30 10:29
 * @Name: realTimeCurrency
 */

const realTimeCurrency = {
  routes: [
    {
      path: '/realTimeCurrency',
      name: 'realTimeCurrency',
      meta: {
        title: ''
      },
      component: () => import('@/project/views/real-time-currency/real-time-currency.vue')
    }
  ]
};
export default realTimeCurrency;



// WEBPACK FOOTER //
// ./src/project/router/realTimeCurrency.js